{
  "visHjelpeskuffAriaLabel": "Go to help about this.",
  "unknownError": "An error has occurred",
  "unknownErrorAction": "Reload the page!",
  "pendingChangesHeader": "There are unsaved changes",
  "pendingChangesClose": "Discard changes",
  "pendingChangesConfirm": "Resume editing",
  "pendingChangesDescription": "If you leave the page, you will lose all changes.",
  "languageChanged": "Language changed to English",
  "breadCrumb_Forsiden": "Home",
  "pageNotFoundHeader": "It seems this page isn’t quite well.",
  "pageNotFoundDescription": "Check for a typo in the URL, or go to the front page.",
  "pageNotFoundToStart": "Go to homepage",
  "sharing_Status_Delt_Med_Barnet": "Shared with child",
  "sharing_Status_Bare_Synlig_For_Deg": "Only visible to you",
  "word_explanation_open": "Open word explanation",
  "word_explanation_close": "Close word explanation",
  "word_explanation_search_description": "If you see words or expressions that you don’t understand, you can search here. Please note that the search results will be displayed in Norwegian only.",
  "word_explanation_search_input_label": "Search",
  "word_explanation_search_submit_button": "Search",
  "word_explanation_search_source_prefix": "Source:",
  "language_norwegian": "Norsk",
  "language_english": "English",
  "language_sami": "Sámi",
  "language_nynorsk": "Nynorsk",
  "language_lithuanian": "Lietuviškai",
  "language_polish": "Polski",
  "language_russian": "Русский",
  "language_romanian": "Română",
  "visHjelpeskuffTekst": "More help",
  "breadcrumb_arialabel": "Breadcrumb trail",
  "language_picker_trigger_text": "Språk/Language",
  "language_ukrainian": "Українська",
  "language_french": "Français",
  "word_explanation_search_container_label": "Word explanations",
  "driftspanel_aria_label": "Service messages",
  "sharing_Status_Skjult_For_Barnet": "Skjult for barnet",
  "sharing_Status_Skjult_For_Fullmektig": "Skjult for fullmektig"
}
